//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';

import newMediaTypesMixin from '@/components/mixins/new-mediatypes.mixin.js';

export default {
  name: 'SubmissionHero',
  mixins: [newMediaTypesMixin],
  props: {
    channelId: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState({
      isLoggedIn: state => state.user.isLoggedIn,
      isArtist: state => state.user.isArtist,
    }),
    currentImageUrl() {
      return _.get(this.mediaTypes[this.channelId], 'bgImage');
    },
    currentImageUrlDark() {
      return _.get(this.mediaTypes[this.channelId], 'bgImageDark');
    },
    imageUrl() {
      return this.currentImageUrl || `https://static.moele.me/img/channels2022/submission/${this.channelId}.230331.png?auto=format&w=1942`;
    },
  },
  methods: {
    onUploadClick() {
      if (!this.isLoggedIn) {
        this.$store.dispatch('modal/showSignUp');
      } else if (this.isArtist) {
        window.location.href = this.$link('/contributor/upload').url();
      } else {
        window.location.href = this.$link('/contributors').url();
      }
    },
  },
};
